// extracted by mini-css-extract-plugin
export default {"wrap":"empty-state-message_wrap__avVs1","text":"empty-state-message_text__Ig0uL"};